import React from 'react'
import { CSSTransition } from 'react-transition-group'
import s from './SlideInOut.less'
import * as Device from '../Device'

const SlideInOut = props => {
  const { display, children } = props

  return __BROWSER__ && !Device.isGE() ? (
    <CSSTransition
      in={display}
      timeout={300}
      classNames={{
        enter: s.slideInEnter,
        enterActive: s.slideInEnterActive,
        exit: s.slideInExit,
        exitActive: s.slideInExitActive
      }}
      unmountOnExit
    >
      {animationState => children(animationState)}
    </CSSTransition>
  ) : (
    <div className={display ? s.show : s.hide}>{children()}</div>
  )
}

export default SlideInOut
